import React from 'react';
import { useTranslation } from 'react-i18next';

export type RadioOption = {
  placeholderTranslationKey: string;
  value: string;
};

interface RadioListProps {
  points: RadioOption[];
  status: RadioOption | null;
  setStatus: (value: RadioOption) => void;
}

const RadioList: React.FC<RadioListProps> = ({ points, status, setStatus }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-2 pt-2">
      {points.map((point) => (
        <label key={point.placeholderTranslationKey} className="flex items-center space-x-2 px-4">
          <input
            type="radio"
            value={point.value}
            checked={status?.value === point.value}
            onChange={() => setStatus(point)}
          />
          <span className="text-sm">{t(`${point.placeholderTranslationKey}`)}</span>
        </label>
      ))}
    </div>
  );
};

export default RadioList;
